(() => {
  if (window.getflyFooterReady) return;
  window.getflyFooterReady = true;
  if (typeof HTMLDialogElement === 'undefined') return;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.footer-sec .footer-drop-a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const list = link.nextElementSibling;
    if (!list?.classList.contains('footer-drop-ul')) return;
    event.preventDefault();
    const dialog = document.createElement('dialog');
    dialog.className = 'gff-dialog';
    dialog.setAttribute('aria-label', link.textContent.trim());
    const title = document.createElement('h2');
    title.textContent = link.textContent.trim();
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close menu');
    const all = document.createElement('a');
    all.href = link.href;
    all.textContent = 'View all ' + title.textContent;
    const intro = document.createElement('p');
    intro.append(all);
    const items = list.cloneNode(true);
    items.removeAttribute('style');
    items.removeAttribute('class');
    dialog.append(title, close, intro, items);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('gff-dialog-open');
      dialog.remove();
      link.focus();
    }, { once: true });
    document.documentElement.classList.add('gff-dialog-open');
    dialog.showModal();
    close.focus();
  });
})();
